module.exports = __webpack_public_path__ + "static/media/css.29637879.svg";